import { useEffect, useState } from "react";
import { packagesApi } from "../api";

// Fallback mirrors the server config so the section still renders if the
// request hasn't resolved yet.
const FALLBACK = [
    { id: "starter", reports: 500, price: 400, perReport: 0.8, popular: false },
    { id: "standard", reports: 1000, price: 700, perReport: 0.7, popular: true },
    { id: "pro", reports: 2000, price: 1200, perReport: 0.6, popular: false },
    { id: "business", reports: 5000, price: 2000, perReport: 0.4, popular: false },
];

function Packages({ contactHref = "mailto:carspacenotification@gmail.com" }) {
    const [packages, setPackages] = useState(FALLBACK);

    useEffect(() => {
        let alive = true;
        packagesApi
            .list()
            .then((res) => {
                if (alive && res.data && Array.isArray(res.data.data)) setPackages(res.data.data);
            })
            .catch(() => {});
        return () => {
            alive = false;
        };
    }, []);

    return (
        <section className="packages">
            <div className="packages__head">
                <h2>Report Packages</h2>
                <p>Prepaid bundles of vehicle-history reports. Pick the volume that fits your business.</p>
            </div>

            <div className="packages__grid">
                {packages.map((p) => (
                    <div key={p.id} className={`pkg-card${p.popular ? " pkg-card--popular" : ""}`}>
                        {p.popular && <span className="pkg-card__badge">Most popular</span>}
                        <div className="pkg-card__reports">{p.reports.toLocaleString()}</div>
                        <div className="pkg-card__reports-label">reports</div>
                        <div className="pkg-card__price">${p.price.toLocaleString()}</div>
                        <div className="pkg-card__per">${p.perReport.toFixed(2)} / report</div>
                        <a className="pkg-card__cta" href={contactHref}>Contact us</a>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Packages;
